import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - Columbia Sensometer`;
  }, [title]);
}

export default useTitle;
